import React from 'react';
import Application from 'src/shared/Application';
import { Provider } from 'mobx-react';
import RootStore from '@stores/RootStore';

const Root = () => (
    <Provider { ...RootStore }>
        <Application />
    </Provider>
)

export default Root;